import style from "./style.scss";

import { Fragment } from "preact";
import { useId } from "preact/hooks";
import Editorial from "../../../../components/editorial";
import CompatibilityIcon from "../compatibility-icon";
import Warning from "../../../../components/warning";
import { usePopup } from "../../../../components/popup/context";
import Popup from "../../../../components/popup";

export const VerificationLegend = () => (
  <Fragment>
    <dl class={style.legend}>
      <div>
        <dt>
          <CompatibilityIcon
            status="direct"
            mini
            style="margin-top:-4px; transform: scale(0.9);"
          />{" "}
          Compatible
        </dt>
        <dd>
          Officially supported and connects directly without extra adapters.
        </dd>
      </div>
      <div>
        <dt>
          <CompatibilityIcon
            status="adapter"
            mini
            style="margin-top:-4px; transform: scale(0.9);"
          />{" "}
          Needs Add-on
        </dt>
        <dd>
          Officially supported, but requires a specific cable, adapter, or
          accessory to connect.
        </dd>
      </div>
      <div>
        <dt>
          <CompatibilityIcon
            status="unofficial-bright"
            mini
            style="margin-top:-4px; transform: scale(0.9);"
          />{" "}
          May Work
        </dt>
        <dd>
          Not officially supported by EcoFlow, but may function in real-world
          testing. An ability to connect does not guarantee safe electrical or
          firmware compatibility. Compatibility could break with firmware
          updates. Attempt at your own risk.
        </dd>
      </div>
      <div>
        <dt>
          <CompatibilityIcon
            status="none"
            mini
            style="margin-top:-4px; transform: scale(0.9);"
          />{" "}
          Not Compatible
        </dt>
        <dd>
          Not officially supported by EcoFlow and expected not to work. An
          ability to connect does not guarantee safe electrical or firmware
          compatibility. Some combinations may function in real-world testing.
          Attempt at your own risk.
        </dd>
      </div>
    </dl>

    <Warning prefix="Note">
      Some compatibility features and adapter support may require updating your
      power station and battery to the latest firmware version via the EcoFlow
      app.
    </Warning>
  </Fragment>
);

export const useVerificationLegendModal = () => {
  const popup = usePopup();
  const modalTitleId = useId();

  const openVerificationLegendModal = (e) => {
    e?.preventDefault?.();

    popup.showPopup(
      <Popup ariaLabelledBy={modalTitleId}>
        <div class={style.popupWrapper}>
          <Editorial>
            <h2 id={modalTitleId}>Compatibility Status Legend</h2>
            <VerificationLegend />
          </Editorial>
        </div>
      </Popup>
    );
  };

  return openVerificationLegendModal;
};
